import { webEvent } from "./event";

// when the user opens the app zoom menu in the top right corner of the app
export const appZoomOpened = () => webEvent("topbar_menu", "app_zoom_opened");

// Triggered when the user changes the zoom level using the app zoom slider
// or the +/- buttons at the top right corner of the app
export const appZoomZoomChanged = () => webEvent("topbar_menu", "app_zoom_changed");

// When the user clicks the connection status link in the user menu
export const userMenuStatusLinkClicked = () => webEvent("user_menu", "status_link_clicked");

// when the user opens the user actions menu at the top right corner of the app
export const userActionsMenuOpened = () => webEvent("user_menu", "opened");

export const bottomMenuToggled = (open: boolean) => webEvent("bottom_menu", "toggled", { open });
